import $ from 'jquery';

$(function(){
	var $cscmailform = $('.csc-mailform');
	$cscmailform.find('.csc-form-confirmation').addClass('col-sm-9 col-sm-push-3');
	$cscmailform.find('.csc-form-confirmation-false').find('input').addClass('btn btn-danger');
	$cscmailform.find('.csc-form-confirmation-true').find('input').addClass('btn btn-primary');
});